"use strict";import{BreadcrumbItem as e}from"./src/BreadcrumbItem.js";customElements.define("sp-breadcrumb-item",e);
//# sourceMappingURL=sp-breadcrumb-item.js.map
